//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
export default {
	data() {
		return {
			myCouponList: [],
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false,
				finished: false
			},
			show: false,
			titList: [{
					name: '未使用',
					code: '0'
				},
				{
					name: '已使用',
					code: '1'
				},
				{
					name: '已过期',
					code: '2'
				}
			],
			state: '0', // 当前tab选项
		}
	},
	onLoad() {
		this.queryData()
	},
	onReachBottom() {
		if (this.myCouponList.length < this.page.count) {
			this.queryData()
		}
	},
	methods: {
		format(time) {
			return moment(time).format('YYYY-MM-DD')
		},
		// tab列表选择
		active(val) {
			this.state = val.code
			this.myCouponList = []
			this.page.currentPage = 1
			this.queryData()
		},
		showRule(item) {
			item.show = !item.show
		},
		// 列表获取
		queryData() {
			this.page.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/coupon/queryCouponDetail',
				data: {
					memberId: this.$store.state.userInfo.memberId,
					useType: this.state,
					pageSize: this.page.pageSize,
					currentPage: this.page.currentPage
				}
			}).then(res => {
				let list = []
				list = res.data.map(t => {
					return {
						...t,
						show: false
					}
				})
				this.myCouponList.push.apply(this.myCouponList, list)
				this.page.count = res.count
				this.page.loading = false
				if (this.myCouponList.length >= this.page.count) {
					this.page.finished = true
				}
				this.page.currentPage += 1
			})
		},
	}
}
